import { Box, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { getCompanyDetails } from "../../api/dataCapture";
import { isPast } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { setCompanyDetails } from "../../redux/reducers/dataCaptures";
import CustomTextField from "../../components/CustomTextField";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { isEmpty } from "../../common/StaticExports";

const CompanyDetails = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const clubDetails = useSelector((state: any) => state.clubDetails);
  const data = useSelector((state: any) => state.dataCaptures.companyDetails);
  const isAdmin = useSelector((state: any) => state.common.isAdmin);
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      const response = await getCompanyDetails({
        clubId: clubDetails.id,
        isPast: false,
      });
      dispatch(setCompanyDetails(response));
    };
    fetchCompanyDetails();
  }, []);

  const updateState = (key: any, updatedData: any) => {
    const updatedState = { ...data, [key]: updatedData };
    dispatch(setCompanyDetails(updatedState));
  };

  return (
    <Box className="liceDataSubContainer">
      <Typography className="standardsHeading uppercase">
        company details
      </Typography>
      <Box className={"licenceDataCDWrapper"}>
        <Box className={"licenceDataCDs"}>
          <CustomTextField
            label={"Company Trading Name"}
            value={data.companyName}
            manageChange={(value: any) => {
              updateState("companyName", value);
            }}
            errorMessage={t("REQUIRED")}
            isError={isEmpty(data.companyName) && !isAdmin}
            isDisabled={isAdmin}
          />
          <CustomTextField
            label={"Name of the Executive Committee Member"}
            value={data.executiveMember}
            manageChange={(value: any) => {
              updateState("executiveMember", value);
            }}
            errorMessage={t("REQUIRED")}
            isError={isEmpty(data.executiveMember) && !isAdmin}
            isDisabled={isAdmin}
          />
          <CustomTextField
            label={"Academy Director"}
            value={data.academyDirector}
            manageChange={(value: any) => {
              updateState("academyDirector", value);
            }}
            errorMessage={t("REQUIRED")}
            isError={isEmpty(data.academyDirector) && !isAdmin}
            isDisabled={isAdmin}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CompanyDetails;
